import { render, staticRenderFns } from "./quizes.vue?vue&type=template&id=0197bdde"
import script from "./quizes.vue?vue&type=script&lang=js"
export * from "./quizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports